import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidDictationSentences } from '../../../../mechanics/rid-dictation-sentences/rid-dictation-sentences';

@Component({
  selector: 'app-dictation-sentences-page',
  imports: [RidDictationSentences],
  templateUrl: './dictation-sentences-page.html',
})
export class DictationSentencesPage {
  protected readonly $router = inject(Router);
}
